import React from 'react';
import Meta from '../components/Meta';
import { ListFeedBanner } from '../components/Banners';
import { ListFeedItem } from '../components/PageHelpers';
import { findRecentStories } from '../util/helperFunctions';

class ReportsFeed extends React.Component {
  render() {
    const { data } = this.props;
    const page = data.mortyPage;
    const reports = data.allReports.edges.map(d => d.node);
    const privacyRoute = '/about-us/reports/vr-privacy-policy/';

    const privacyReport = reports.find(o => o.route === privacyRoute);
    const filtered = reports.filter(o => o.route !== privacyRoute);

    const listData = findRecentStories(filtered);
    const bannerPage = listData.shift();

    return (
      <div>
        <Meta page={page} />
        <div className={`list-feed ${page.title}`} />
        <ListFeedBanner page={page} latest={bannerPage} />
        <div className="pt2 pb3 pt3-l pb5-l flex flex-column items-center justify-center">
          <div className="w-100 mw-1060 three-up-grid">
            {listData.map(d => <ListFeedItem key={d.id} page={d} />)}
            <ListFeedItem page={privacyReport} />
          </div>
        </div>
      </div>
    );
  }
}

export default ReportsFeed;

export const pageQuery = graphql`
  query ReportsFeed($id: String!) {
    mortyPage(id: { eq: $id }) {
      title
      route
      subtitle
      route
      metaTitle
      metaDescription
      metaKeywords
    }
    allReports: allMortyPage(filter: {
      route: { ne: "/dummy-page" }
      section: { eq: "Reports" }
  }) {
      edges {
        node {
          id
          title
          route
          section
          template
          publishedDate
          updatedAt
          abstractPhotoAltText
          abstractPhotoFocalPointX
          abstractPhotoFocalPointY
          abstractPhoto {
            url
          }
        }
      }
    }
  }
`;

export const previewQuery = `
query ReportsFeed($id: String!) {
  mortyPage(id: { eq: $id }) {
    title
    route
    subtitle
    route
    metaTitle
    metaDescription
    metaKeywords
  }
  allReports: allMortyPage(filter: {
    route: { ne: "/dummy-page" }
    section: { eq: "Reports" }
}) {
    edges {
      node {
        id
        title
        route
        template
        section
        publishedDate
        updatedAt
        abstractPhotoAltText
        abstractPhotoFocalPointX
        abstractPhotoFocalPointY
        abstractPhoto {
          url
        }
      }
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/templates/Reports-Feed.js